var _rect, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.890137,
    y: 0.0297852,
    width: 26.9401,
    height: 26.9401,
    rx: 13.47,
    fill: "url(#paint0_linear_1_437)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9964 10.2744H13.2183V20.1037H16.2099V15.342C16.2099 13.7464 16.7974 12.7308 18.2101 12.7308C19.2284 12.7308 19.6298 13.6727 19.6298 15.342V20.1037H22.6204V14.6743C22.6204 11.7433 21.9197 10.1458 18.9645 10.1458C17.423 10.1458 16.3972 10.8676 15.9964 11.6696V10.2744Z",
    fill: "#FCFFFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0808 19.9759H8.08908V10.1458H11.0808V19.9759Z",
    fill: "#FCFFFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3748 7.68876C11.4687 7.45048 11.5143 7.19576 11.5089 6.93964C11.4976 6.43684 11.29 5.95836 10.9305 5.6067C10.5711 5.25501 10.0882 5.05811 9.58545 5.05811C9.08219 5.05811 8.59932 5.25501 8.23985 5.6067C7.88037 5.95836 7.67327 6.43684 7.66201 6.93964C7.6561 7.19576 7.70171 7.45048 7.79614 7.68876C7.89003 7.92705 8.03114 8.14414 8.21034 8.32729C8.32354 8.44328 8.45124 8.54422 8.58912 8.62785C8.66907 8.67627 8.75276 8.71892 8.83915 8.75534C9.07575 8.85467 9.32899 8.90584 9.58545 8.90584C9.84138 8.90584 10.0952 8.85467 10.3312 8.75534C10.5673 8.65598 10.7814 8.51045 10.9606 8.32729C11.0749 8.21053 11.1736 8.07999 11.2541 7.93895C11.3002 7.85874 11.3404 7.77514 11.3748 7.68876Z",
    fill: "#FCFFFE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_437",
    x1: 14.3602,
    y1: 0.0297852,
    x2: 14.3602,
    y2: 26.9699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0CD8AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0CD845"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinked);
export default __webpack_public_path__ + "static/media/linked.91a790560d967e4c4e4d8c343bce5a56.svg";
export { ForwardRef as ReactComponent };